import { render, staticRenderFns } from "./NkChart.vue?vue&type=template&id=bbcb05c0&scoped=true"
import script from "./NkChart.vue?vue&type=script&lang=js"
export * from "./NkChart.vue?vue&type=script&lang=js"
import style0 from "./NkChart.vue?vue&type=style&index=0&id=bbcb05c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcb05c0",
  null
  
)

export default component.exports